import { render, staticRenderFns } from "./check.vue?vue&type=template&id=77131a22&scoped=true"
import script from "./check.vue?vue&type=script&lang=ts"
export * from "./check.vue?vue&type=script&lang=ts"
import style0 from "./check.vue?vue&type=style&index=0&id=77131a22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77131a22",
  null
  
)

export default component.exports